import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
    FiPlayCircle, FiZap, FiAward, FiBookOpen, FiUsers, FiClock,
    FiArrowRight, FiMessageCircle, FiSun, FiMoon, FiLock
} from 'react-icons/fi';
import api, { RUTA_ARCHIVOS } from '../api/client';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import Estrellas from '../components/Estrellas';

export default function Landing() {
    const { usuario } = useAuth();
    const { tema, cambiarTema } = useTheme();
    const navigate = useNavigate();
    const [cursos, setCursos] = useState([]);

    useEffect(() => {
        if (usuario) {
            navigate('/dashboard', { replace: true });
            return;
        }
        api.get('/cursos')
            .then(r => setCursos((r.data.cursos || []).slice(0, 4)))
            .catch(() => {});
    }, [usuario, navigate]);

    return (
        <div className="landing">
            <nav className="landing-nav">
                <Link to="/" className="marca" style={{ textDecoration: 'none' }}>
                    <div className="icon-box"><FiMessageCircle size={18} /></div>
                    Chucho Cursos
                </Link>
                <div className="acciones">
                    <Link to="/login" className="btn btn-fantasma">Iniciar Sesion</Link>
                    <Link to="/registro" className="btn btn-primario">Crear cuenta</Link>
                </div>
            </nav>

            <section className="hero">
                <h1>Aprende a tu ritmo, <span>certificate al final</span></h1>
                <p>
                    Plataforma de cursos en linea con videos en secuencia, resumenes generados
                    por inteligencia artificial y certificado descargable al completar.
                </p>
                <div className="hero-ctas">
                    <Link to="/registro" className="btn btn-primario">
                        Empezar gratis <FiArrowRight />
                    </Link>
                    <Link to="/login" className="btn btn-fantasma">
                        Ya tengo cuenta
                    </Link>
                </div>
            </section>

            <section className="seccion-landing">
                <h2>¿Por que elegir Chucho Cursos?</h2>
                <p className="subt">Diseñado para que aprendas sin distracciones</p>

                <div className="beneficios">
                    <div className="beneficio">
                        <div className="icon"><FiPlayCircle size={22} /></div>
                        <h3>Videos en secuencia</h3>
                        <p>Avanza paso a paso, sin saltarte lecciones, para no perderte ningun concepto importante.</p>
                    </div>
                    <div className="beneficio">
                        <div className="icon"><FiZap size={22} /></div>
                        <h3>Resumenes con IA</h3>
                        <p>Cada leccion incluye un resumen automatico generado con Gemini para reforzar lo aprendido.</p>
                    </div>
                    <div className="beneficio">
                        <div className="icon"><FiAward size={22} /></div>
                        <h3>Certificado al terminar</h3>
                        <p>Al completar el curso y pasar el examen final obtienes un PDF descargable como reconocimiento.</p>
                    </div>
                    <div className="beneficio">
                        <div className="icon"><FiUsers size={22} /></div>
                        <h3>Comunidad activa</h3>
                        <p>Comenta, califica y comparte tu experiencia con otros estudiantes despues de cada curso.</p>
                    </div>
                    <div className="beneficio">
                        <div className="icon"><FiClock size={22} /></div>
                        <h3>A tu ritmo</h3>
                        <p>Estudia cuando quieras, donde quieras. La plataforma guarda tu progreso automaticamente.</p>
                    </div>
                    <div className="beneficio">
                        <div className="icon"><FiLock size={22} /></div>
                        <h3>Cuentas seguras</h3>
                        <p>Contrasenas encriptadas con bcrypt, sesiones con JWT y verificacion por correo electronico.</p>
                    </div>
                </div>
            </section>

            {cursos.length > 0 && (
                <section className="seccion-landing" style={{ background: 'var(--bg-elevado)', borderTop: '1px solid var(--borde)', borderBottom: '1px solid var(--borde)' }}>
                    <h2>Algunos de nuestros cursos</h2>
                    <p className="subt">Disponibles ahora mismo en la plataforma</p>

                    <div className="cursos-grid" style={{ maxWidth: 1100, margin: '0 auto' }}>
                        {cursos.map(c => (
                            <Link
                                key={c.id}
                                to="/registro"
                                className="curso-card"
                                style={{ textDecoration: 'none', color: 'inherit' }}
                            >
                                <div className="curso-cover">
                                    {c.imagen_portada ? (
                                        <img src={c.imagen_portada.startsWith('http') ? c.imagen_portada : `${RUTA_ARCHIVOS}${c.imagen_portada}`} alt={c.nombre} />
                                    ) : <FiBookOpen />}
                                    {c.nivel && <span className="badge">{c.nivel}</span>}
                                </div>
                                <div className="curso-body">
                                    <h3 className="curso-titulo">{c.nombre}</h3>
                                    <p className="curso-prof">{c.profesor_nombre || 'Sin profesor'}</p>
                                    <div className="curso-meta">
                                        <Estrellas valor={Math.round(c.calificacion_promedio || 0)} soloLectura tamano={14} />
                                        <span><FiPlayCircle size={12} /> {c.total_videos || 0}</span>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>

                    <div style={{ textAlign: 'center', marginTop: 36 }}>
                        <Link to="/registro" className="btn btn-primario">
                            Ver todos los cursos <FiArrowRight />
                        </Link>
                    </div>
                </section>
            )}

            <section className="seccion-landing" style={{ textAlign: 'center', paddingBottom: 80 }}>
                <h2>¿Listo para empezar?</h2>
                <p className="subt">Crea tu cuenta gratis y empieza tu primer curso hoy mismo</p>
                <div className="hero-ctas">
                    <Link to="/registro" className="btn btn-primario">Crear cuenta gratis <FiArrowRight /></Link>
                </div>
            </section>

            <footer className="landing-footer">
                Chucho Cursos &copy; {new Date().getFullYear()} - Plataforma de aprendizaje en linea
            </footer>

            <button
                className="tema-toggle-flotante"
                onClick={cambiarTema}
                title={`Cambiar a tema ${tema === 'oscuro' ? 'claro' : 'oscuro'}`}
            >
                {tema === 'oscuro' ? <FiSun size={18} /> : <FiMoon size={18} />}
            </button>
        </div>
    );
}
